import { Tab } from "bootstrap";
import React, { useEffect, useState } from "react";
import { Tabs } from "react-bootstrap";
import { Container } from "reactstrap";
import Footer from "../../components/user/Footer";
import { toast } from "react-toastify";
import { getData, putData } from "../../api/method";
import Waitting from "../../components/user/Order/waitting";
import All from "../../components/user/Order/all";
import Received from "../../components/user/Order/received";
import Delivery from "../../components/user/Order/delivery";
import Cancel from "../../components/user/Order/cancel";
import Pagination from "../../components/pagination";

const username = localStorage.getItem("username");

function MyOrder(args) {
  const [data, setData] = useState([]);

  const [openShip, setOpenShip] = useState(false);

  const toggleShip = () => setOpenShip(!openShip);

  const closeBtnShip = (
    <button className="close" onClick={toggleShip}>
      &times;
    </button>
  );

  const [openShip2, setOpenShip2] = useState(false);

  const toggleShip2 = () => setOpenShip2(!openShip2);

  const closeBtnShip2 = (
    <button className="close" onClick={toggleShip2}>
      &times;
    </button>
  );

  const getCartbyUser = async () => {
    try {
      const result = await getData(`/user?username=${username}`);
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCartbyUser();
  }, [data]);

  const [dataEdit, setDataEdit] = useState([]);

  const getOrderById = async (id) => {
    try {
      const result = await getData(`/api/Order/${id}`);
      setDataEdit(result.data);
      setOpenShip(true);
    } catch (error) {
      console.log(error);
    }
  };

  const getOrderById2 = async (id) => {
    try {
      const result = await getData(`/api/Order/${id}`);
      setDataEdit(result.data);
      setOpenShip2(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitCancel = async (id) => {
    const editData = new FormData();

    editData.append("id", id);
    editData.append("status", 3);
    editData.append("address", dataEdit.address);
    editData.append("ward", dataEdit.ward);
    editData.append("district", dataEdit.district);
    editData.append("city", dataEdit.city);
    editData.append("userId", dataEdit.userId);

    try {
      const res = await putData(`/api/Order/${id}`, editData);
      if (res.status === 200) {
        toast.success("Success!");
        setOpenShip2(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("Fail!");
    }
  };

  const handleSubmitReceive = async (id) => {
    const editData = new FormData();

    editData.append("id", id);
    editData.append("status", 2);
    editData.append("address", dataEdit.address);
    editData.append("ward", dataEdit.ward);
    editData.append("district", dataEdit.district);
    editData.append("city", dataEdit.city);
    editData.append("userId", dataEdit.userId);

    try {
      const res = await putData(`/api/Order/${id}`, editData);
      if (res.status === 200) {
        toast.success("Success!");
        setOpenShip(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("Fail!");
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(2);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="pt-3">
      <div className="bg_breadcrumb">
        <p className="fs-3 fw-bold t-white text-center t-breadcrumb">
          My Order
        </p>
      </div>

      <Container className="py-5">
        <Tabs
          defaultActiveKey="all"
          id="fill-tab-example"
          className="tabs_content w-100"
          fill
        >
          <Tab eventKey="all" title="All">
            <All
              data={currentData}
              getOrderById2={(id) => getOrderById2(id)}
              getOrderById={(id) => getOrderById(id)}
            />

            <Pagination
              paginate={paginate}
              postsPerPage={dataPerPage}
              totalPosts={data.length}
            />
          </Tab>

          <Tab eventKey="wait" title="Waitting">
            <Waitting
              data={data}
              getOrderById2={(id) => getOrderById2(id)}
              openShip2={openShip2}
              toggleShip2={toggleShip2}
              closeBtnShip2={closeBtnShip2}
              handleSubmitCancel={() => handleSubmitCancel(dataEdit.id)}
            />
          </Tab>

          <Tab eventKey="Delivery" title="Delivery">
            <Delivery
              data={data}
              getOrderById={(id) => getOrderById(id)}
              openShip={openShip}
              toggleShip={toggleShip}
              closeBtnShip={closeBtnShip}
              handleSubmitReceive={() => handleSubmitReceive(dataEdit.id)}
            />
          </Tab>

          <Tab eventKey="received" title="Received">
            <Received data={data} />
          </Tab>

          <Tab eventKey="cancelled" title="Cancelled">
            <Cancel data={data} />
          </Tab>
        </Tabs>
      </Container>

      <Footer />
    </div>
  );
}

export default MyOrder;
